import APIKit from "../Allapis/Apikit/apikit";
// import APIKit from "../Allapis/Apikit/apikit";

export const getuserProfile = async (user_id) => {
  const response = await APIKit.get(`/admin/users/${user_id}`);
  const data = await response.json();
  return data;
};

export const updateUserspro = async (Data, userpro_id) => {
  const res = await APIKit.put(`/admin/users/${userpro_id}`, Data);
  return res.data;
};

export const editUsers = async (id) => {
  try {
    const url = `/admin/users/${id}`;
    const result = await APIKit.get(url);
    return result.data;
  } catch (e) {
    return e.response ? e.response : e;
    // return e.response ? e.response : e;
  }
};
// export const updateUsers = async (values) => {};
export const updateUsers = async (values) => {
  try {
    const url = `/admin/users/update`;
    const sendType = { ...values, type: "profile" };
    const result = await APIKit.put(url, sendType);
    return result.data;
  } catch (e) {
    return e.response ? e.response : e;
  }
};
